import React, { useState } from 'react';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import { useSelector, useDispatch } from 'react-redux';
import { GOTO_PAGE } from '../../HOME/REDUX/actions';
import BackButton from '../COMPONENTS/BackButton';
import { GradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import _ from 'lodash';
import StarIcon from '../../HOME/SVG/StarIcon';
import { SELECT_SIZE } from '../REDUX/actions';
import { HELPED_KEY } from '../const';
import { GAME_PAGE, HELP_PAGE, SIZE_PAGE } from '../../HOME/const';
import * as f from '../logic';
import { UPDATE_STATS } from '../../PN/REDUX/actions';
import { dbget } from '../../HOME/utils';

const SizePage = () => {
  const dispatch = useDispatch();
  const [size, setSize] = useState(null);
  const { pn } = useSelector(state => state);

  const handleSize = () => {
    f.getStats({ ...pn, size }, stats => {
      dispatch({ type: UPDATE_STATS, stats });
    });

    dispatch({ type: SELECT_SIZE, size });

    dbget(HELPED_KEY, helped =>
      dispatch({ type: GOTO_PAGE, payload: { page: helped || pn.helped ? GAME_PAGE : HELP_PAGE, fromPage: SIZE_PAGE } })
    );
  };

  const pulseString = useSpring({
    transform: `scale(${size ? 0.75 : 1})`,
    onRest: () => {
      if (size) {
        handleSize();
      }
    },
    config: { duration: 200 },
  });

  return (
    <div className="page-root">
      <div className="ms-logo-title">
        <span className="pn-title">Draw Pile</span>
      </div>
      <div className="pn-page" style={{ backgroundImage: GradientBackground, paddingTop: '1em' }}>
        {_.map([1, 2, 3, 4, 5], op => {
          const { name: label, color } = f.sizeInfo(op, true);
          const width = 30 + op * 6;
          const dx = (5 - op) * 3;
          const margin = `0 ${dx}px`;
          const style = op === size ? pulseString : {};
          return (
            <animated.div key={op} className="pn-tile pn-option pn-size-option" style={style} onClick={() => setSize(op)}>
              <span style={{ gridArea: '1/1', margin }}>
                <StarIcon width={width} strokeWidth={4} rounded color={color} />
              </span>
              <div className="pn-title pn-option-text" style={{ fontSize: '32px' }}>
                {label}
              </div>
            </animated.div>
          );
        })}
        <BackButton />
        <HomeButton />
      </div>
    </div>
  );
};

export default SizePage;
